import { render, staticRenderFns } from "./DataResources.vue?vue&type=template&id=cfce3904&scoped=true&"
import script from "./DataResources.vue?vue&type=script&lang=js&"
export * from "./DataResources.vue?vue&type=script&lang=js&"
import style0 from "./DataResources.vue?vue&type=style&index=0&id=cfce3904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce3904",
  null
  
)

export default component.exports